import React, { useEffect } from 'react';
import './VideoModal.css';

const VideoModal = ({ isOpen, youtubeId, videoSrc, onClose }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="vmodal" onClick={handleBackdropClick}>
      <div className="vmodal-container">
        <button
          className="vmodal-close"
          onClick={onClose}
          aria-label="Fechar"
        >
          ×
        </button>
        {videoSrc ? (
          <video
            className="vmodal-frame"
            src={videoSrc}
            controls
            autoPlay
            playsInline
          />
        ) : (
          <iframe
            className="vmodal-frame"
            title="Vídeo do depoimento"
            src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0&playsinline=1`}
            allow="autoplay;encrypted-media;fullscreen"
            allowFullScreen
          />
        )}
      </div>
    </div>
  );
};

export default VideoModal;
